import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import ConciergeBanner from "../../images/luxury-concierge-banner.png"
import UploadIcon from "../../images/upload-concierge-icon.png"
import Dropzone from "react-dropzone"
// Arrows
import ArrowDown from "../../images/arrowsDown.png"
import ArrowNext from "../../images/arrow-right2.png"
import ArrowNextList from "../../images/arrow-right.png"

// Envelope
import SuccessEnvelope from "../../images/success-concierge.png"
import ErrorEnvelope from "../../images/fail-concierge.png"

// Background
import Background from "../../images/concierge-bg-desktop.png"

// Exit icon
import DeleteButton from "../../images/delete-btn-concierge.png"
import CloseButtonSuccessModal from "../../images/close-button-search.png"

import { getHistoryShipping, doFetchCountries } from '../../actions/postalCodeAction';

import { postConcierge, getConcierge } from "../../actions/productAction"

// Modal
import ModalAddressBook from "../Modals/ModalAddressBookV3"
import ModalLoginNew from "../Modals/ModalLoginNew"
import ModalConciergeList from "../Modals/ModalConciergeList"

// Spinner
import { Modal } from "reactstrap"

// Router
import { withRouter, history } from "react-router-dom"
import { connect } from "react-redux"
import InputNumber from 'Reuseables/InputNumber/InputNumber'

function LuxuryConcierge({ shippingHistory, getHistoryShipping, countries, cities, provinces, postConcierge, isLoggedIn, history, match, getConcierge, conciergeData, doFetchCountries, countdown_modal }) {

  const [selectedOption, setSelectedOption] = useState("62")
  const [name, setName] = useState("")
  const [phone, setPhone] = useState(null)
  const [productName, setProductName] = useState("")
  const [brandNew, setBrandNew] = useState(false)
  const [used, setUsed] = useState(false)
  const [file, setFile] = useState("")
  const [imageUrl, setImageUrl] = useState("")
  const [proceed, setProceed] = useState(false)
  const [selectedShipping, setSelectedShipping] = useState(null)
  const [modalToggle, setModalToggle] = useState(false)
  const [error, setError] = useState("")
  const [addShipping, setAddShipping] = useState(false)
  const [shippingId, setShippingId] = useState(0)
  const [defaultId, setDefaultId] = useState(0)
  const [uploadLoading, setUploadLoading] = useState(false)
  const [submitSuccessfull, setSubmitSuccessful] = useState(false)
  const [submitError, setSubmitError] = useState(false)
  const [showModalLogin, setShowModalLogin] = useState(false)
  const [showConciergeList, setShowConciergeList] = useState(false)
  const [selectedAddressId, setSelectedAddressId] = useState(0)
  const [imageHover, setImageHover] = useState(false)
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);

  useEffect(() => {
    if (file && imageUrl && name && phone && (brandNew || used) && shippingHistory) {
      setProceed(true)
    } else {
      setProceed(false)
    }
  }, [file, imageUrl, name, phone, brandNew, used, shippingHistory])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (match.params.category !== "luxury") {
      history.replace("/404")
    } else {
      doFetchCountries()
      getConcierge()
    }
  }, [])

  useEffect(() => {
    if (isLoggedIn) {
      getHistoryShipping()
        .then(data => {
          const addresses = data.value.data.find(item => item.is_default)
          setShippingId(addresses.id)
        })
        .catch(e => null)
    } else {
      history.push("/login")
    }
  }, [isLoggedIn, showModalLogin])

  useEffect(() => {
    if (shippingHistory.length > 0) {
      const temp = shippingHistory.find(item => item.is_default)

      setSelectedShipping(temp ? temp.alias : shippingHistory[0].alias)
      setDefaultId(temp ? temp.id : shippingHistory[0].id)
      setSelectedAddressId(temp ? temp.id : shippingHistory[0].id)
      setShippingId(temp ? temp.id : shippingHistory[0].id)
    }
  }, [shippingHistory])

  function submitConcierge(e) {
    e.preventDefault()

    const payload = {
      name,
      product_name: productName,
      phone_number: parseInt(selectedOption + phone),
      shipping_id: !shippingId ? defaultId : shippingId,
      image: file
    }

    if (brandNew === true) {
      payload.condition = "BARU"
    }

    if (used === true) {
      payload.condition2 = "BEKAS"
    }

    postConcierge(payload)
      .then(data => {
        if (data.action.payload.status_code === 200) {
          submitOnToggle()
          setSelectedOption("62")
          setName("")
          setPhone("")
          setProductName("")
          setBrandNew(false)
          setUsed(false)
          setFile("")
          setImageUrl("")
          setProceed(false)
          setAddShipping(false)
          getConcierge()
        } else {
          submitErrorOnToggle()
        }
      })
      .catch(_ => submitErrorOnToggle())
  }

  function optionSelect(e) {
    setSelectedOption(e.target.value)
  }

  function shippingSelect(e) {
    setSelectedShipping(e.target.value)
  }

  function inputConditionHandler(payload) {
    payload === "brandnew" ? setBrandNew(!brandNew) : setUsed(!used)
  }

  function handleShowConciergeList() {
    setShowConciergeList(!showConciergeList)
  }

  function inputNameHandler(e) {
    setName(e.target.value)
  }

  function inputPhoneHandler(e) {
    if (e.target.value > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength)
      setPhone(e.target.value)
    } else {
      setPhone(e.target.value)
    }
  }

  function productNameHandler(e) {
    setProductName(e.target.value)
  }

  function phoneKeyPress(e) {
    let event = e || window.event;

    // Handle key only accept number
    let key = event.keyCode || event.which
    key = String.fromCharCode(key)

    const regex = /[0-9]|\./

    if (!regex.test(key)) {
      event.returnValue = false
      if (event.preventDefault) event.preventDefault()
    }
  }

  function uploadImage() {
    document.getElementById("fileInput").click()
  }

  function handleImageInput(e) {
    e.preventDefault()
    setUploadLoading(true)

    let drive = new FileReader();
    let image = e.target.files[0]

    drive.onloadend = () => {
      setFile(image)
      setImageUrl(drive.result)
    }

    setUploadLoading(false)
    if (image && image.type.match('image.*')) {
      return drive.readAsDataURL(image);
    } else {
      return null
    }
  }

  function changeId(id) {
    setShippingId(id)
    setIsAddressButtonDisable(true)
  }

  function showModal() {
    setModalToggle(!modalToggle)
  }

  function submitShipping(id) {
    setIsAddressButtonDisable(false)
    if (id) {
      setDefaultId(id)
      const temp = shippingHistory.filter(item => item.id === id)[0]
      setSelectedAddressId(temp.id)
      setSelectedShipping(temp.alias)
      setShippingId(temp.id)
      setModalToggle(!modalToggle)
    } else {
      setDefaultId(shippingId)
      const temp = shippingHistory.filter(item => item.id === shippingId)[0]
      setSelectedAddressId(temp.id)
      setSelectedShipping(temp.alias)
      setShippingId(temp.id)
      setModalToggle(!modalToggle)
    }
  }

  function handleClearImage() {
    setImageUrl("")
  }

  function submitOnToggle() {
    setSubmitSuccessful(!submitSuccessfull)
  }

  function submitErrorOnToggle() {
    setSubmitError(!submitError)
  }

  function redirectAfterAuth() {
    if (isLoggedIn) {
      setShowModalLogin(!showModalLogin)
      history.replace("/luxury/concierge")
    } else {
      history.replace("/luxury")
    }
  }

  const onDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  }

  const onDragEnter = (e) => {
    e.stopPropagation();

    console.log('test enter')
  }

  const onFileDrop = (e, target) => {
    e.preventDefault();

    let files = e.dataTransfer.files[0]

    setUploadLoading(true)

    let drive = new FileReader();
    let image = files

    drive.onloadend = () => {
      setFile(image)
      setImageUrl(drive.result)
    }

    setUploadLoading(false)
    if (image && image.type.match('image.*')) {
      return drive.readAsDataURL(image);
    } else {
      return null
    }
  }


  return (
    <div style={{ backgroundImage: window.screen.availWidth > 480 && `url(${Background})` }} className={countdown_modal ? "concierge-container3 is-countdown-active" : "concierge-container3"}>
      {
        <ModalConciergeList conciergeData={conciergeData} isOpen={showConciergeList} onToggle={handleShowConciergeList} />
      }
      {
        <Modal className={"modal-concierge-success-submit"} isOpen={submitSuccessfull || submitError} toggle={submitSuccessfull ? submitOnToggle : submitErrorOnToggle}>
          <div className="concierge-submit-modal">
            <KickImage onClick={submitSuccessfull ? submitOnToggle : submitErrorOnToggle} alt="Close modal" src={CloseButtonSuccessModal} className="close-button-success-modal" />
            <KickImage src={submitSuccessfull ? SuccessEnvelope : ErrorEnvelope} className="concierge-submit-envelope" alt="Successfully submit" />
            {
              submitSuccessfull ? <div className="concierge-submit-text">
                <h4>Your request has been successfully submitted!</h4>
                <h6>We will reach you as soon as possible</h6>
              </div> : <div className="concierge-submit-text">
                <h4>There was an error submitting your request</h4>
                <h6>Unable to submit your request. Please try again later.</h6>
              </div>
            }
          </div>
        </Modal>
      }
      {
        <Modal isOpen={uploadLoading} onToggle={handleImageInput}>
          <h4>Uploading your image</h4>
        </Modal>
      }
      {
        <ModalAddressBook
          isOpen={modalToggle}
          onToggle={showModal}
          dataAddress={shippingHistory}
          countries={countries}
          provinces={provinces}
          cities={cities}
          id={shippingId}
          changeId={changeId}
          defaultId={defaultId}
          submitShipping={submitShipping}
          modalTitle={'Change Address'}
          getHistoryShipping={getHistoryShipping}
          isAddressButtonDisable={isAddressButtonDisable}
          selectedAddresId={selectedAddressId !== 0 ? selectedAddressId : null}
        />
      }
      <div style={{ backgroundImage: window.screen.availWidth < 480 && `url(${Background})` }} className="concierge-left">
        <h4>Concierge Service Request</h4>
        <p>Let us know about your wishlist so that we can find the best deal around just for you.</p>
        <div onClick={() => handleShowConciergeList()} className="button">
          <p>Concierge List</p>
          <KickImage src={ArrowNextList} alt="right arrow" />
        </div>
      </div>
      <div className="concierge-right">
        <div style={{ paddingTop: window.screen.availWidth < 480 && "32px" }} className="form-name">
          <h4>Name</h4>
          <input value={name} type="text" onChange={inputNameHandler} placeholder="Enter Your Name" />
        </div>
        <div className="form-phone">
          <h4>Phone Number</h4>
          <div className="select-input">
            <select style={{ background: `url(${ArrowDown})`, cursor: "pointer" }} onChange={optionSelect} value={selectedOption}>
              {
                countries && countries.map(item => (
                  <option key={item.id} value={item.phone_code}>{`+${item.phone_code}`}</option>
                ))
              }
            </select>
            <InputNumber maxLength={16} onChange={inputPhoneHandler} value={phone} placeholder="Phone Number" />
          </div>
        </div>
        <div className="form-name">
          <h4>Product Name</h4>
          <input value={productName} type="text" onChange={productNameHandler} placeholder="Enter Product Name" />
        </div>
        <div className="form-condition">
          <h4>Condition <span>(You can pick more than one)</span></h4>
          <div className="select-condition">
            <div style={brandNew ? { backgroundColor: "#242424", color: "#f1f1f1" } : {}} onClick={() => inputConditionHandler("brandnew")} className="condition-brand-new">
              Brand New
            </div>
            <div style={used ? { backgroundColor: "#242424", color: "#f1f1f1" } : {}} onClick={() => inputConditionHandler("used")} className="condition-used">
              Used
            </div>
          </div>
        </div>
        <div className="form-shipping">
          <h4>Shipping Address</h4>
          <div className="input-shipping" style={{ background: `url(${ArrowNext})`, cursor: 'pointer' }} onClick={() => showModal()}>
            {shippingHistory.length > 0 && selectedShipping}
          </div>
        </div>
        <div className="form-image">
          <h4>Upload Image</h4>
          {
            !imageUrl ? <div onClick={() => uploadImage()} className="upload-container">
              <input accept="image/*" onChange={handleImageInput} type="file" id="fileInput" style={{ display: "none" }} />
              <div className="upload-content">
                <KickImage src={UploadIcon} alt="upload image here" />
                <h6>Drag and drop your image here or <span>browse</span></h6>
              </div>
            </div> : <div onMouseEnter={() => setImageHover(true)} onMouseLeave={() => setImageHover(false)} className="image-container">
              {
                imageHover &&
                <KickImage onClick={() => handleClearImage()} className="close-modal" src={DeleteButton} alt="close" />
              }
              <div style={{ filter: imageHover && "brightness(70%)" }} className="image-content">
                <KickImage src={imageUrl} alt="delete image" />
              </div>
            </div>
          }
        </div>
        <div className="form-submit">
          <div onClick={(e) => submitConcierge(e)} style={proceed ? { backgroundColor: "#159953", color: "white", marginBottom: '15px' } : { backgroundColor: "#e0e0e0", color: "#242424", marginBottom: "15px" }} className="button-submit">
            <h4 style={{ color: proceed ? "#fff" : "#bebebe" }}>Submit</h4>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  shippingHistory: state.dataPostalCode.shippingHistory.data,
  countries: state.dataPostalCode.countries.data,
  cities: state.dataPostalCode.cities.data,
  provinces: state.dataPostalCode.provinces.data,
  isLoggedIn: state.dataAuth.isLogged,
  conciergeData: state.dataProduct.concierge.data,
  countdown_modal: state.dataMenu.countdown_modal,
})

const mapDispatchToProps = dispatch => ({
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  postConcierge: payload => dispatch(postConcierge(payload)),
  getConcierge: () => dispatch(getConcierge()),
  doFetchCountries: () => dispatch(doFetchCountries())
})


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LuxuryConcierge));
